import { render, staticRenderFns } from "./SingleLeadNotificationSettings.vue?vue&type=template&id=70c3a2ca"
import script from "./SingleLeadNotificationSettings.vue?vue&type=script&lang=js"
export * from "./SingleLeadNotificationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports